var map = {
	"./icon_einspeiseverguetung_white.svg": 13157,
	"./icon_elektromobilitaet_personenfahrzeuge_white.svg": 50620,
	"./icon_erneuerbare_heizung_white.svg": 14060,
	"./icon_solarenergie_white.svg": 43676,
	"./icon_strompreis_haushalt_white.svg": 60912,
	"./icon_stromproduktion_erneuerbare_energien_white.svg": 86944,
	"./icon_stromverbrauch_person_white.svg": 21704
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89160;